import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class CertificazioniService {
  static getAllCertificazioni = () => {
    let url = `${REACT_APP_REST_ENDPOINT}/certificazioni`;
    return ApiService.getRudeRequest(url);
  };

  static getCertificazioniByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/certificazioni/find`;
      ApiService.postRudeRequest(resolve, reject, url, params);
    });
  };

  static createCertificazione = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/certificazioni/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteCertificazione = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/certificazioni/delete`;
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateCertificazione = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/certificazioni/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}

